import { useEffect, useState } from "react";
import { FieldValues, FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import { getAllPrices } from "../../../services/Pricing.service";
import PricingTable from "./PricingTable";
import SearchTrip from "./SearchTrip";

export type Inputs = {
  tripId: number;
  ageGroupId: number;
  isTwoWayTrip: boolean;
  lineId: number;
};

const Prices: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [tripParams, setTripParams] = useState<Inputs>({
    tripId: 0,
    ageGroupId: 0,
    lineId: 0,
    isTwoWayTrip: true
  });
  const { response, handleFunc, loading } = useFetch(getAllPrices, {
    initRequest: false
  });

  const methods = useForm<Inputs>();
  const { setValue } = methods;

  useEffect(() => {
    if (searchParams.has("lineId") && searchParams.has("tripId") && searchParams.has("tripTime")) {
      const lineId = Number(searchParams.get("lineId"));
      const tripId = Number(searchParams.get("tripId"));
      const ageGroupId = 1;
      const isTwoWayTrip = false;

      setValue("lineId", lineId);
      setValue("tripId", tripId);
      setValue("ageGroupId", ageGroupId);
      setValue("isTwoWayTrip", isTwoWayTrip);

      if (lineId && tripId && ageGroupId) {
        const params = {
          lineId,
          tripId,
          ageGroupId,
          isTwoWayTrip
        };
        setTripParams(params);
        void handleFunc(params);
      }
    }
  }, [searchParams, setValue, handleFunc]);

  const handlePricingSubmit = (data: FieldValues) => {
    const tripId = Number(data.tripId);
    const ageGroupId = Number(data.ageGroupId);
    const lineId = Number(data.lineId);
    const isTwoWayTrip = Boolean(data.isTwoWayTrip);

    if (!tripId || !ageGroupId || !lineId) return;

    const params = { tripId, ageGroupId, lineId, isTwoWayTrip };
    void handleFunc(params);
    setTripParams(params);
  };

  const onSubmit: SubmitHandler<FieldValues> = (data) => {
    handlePricingSubmit(data);
  };

  const handleCheckboxChange = (isTwoWayTrip: boolean) => {
    const currentValues = methods.getValues();
    const tripId = Number(currentValues.tripId);
    const ageGroupId = Number(currentValues.ageGroupId);
    const lineId = Number(currentValues.lineId);

    if (tripId && ageGroupId && lineId) {
      const params = { tripId, ageGroupId, lineId, isTwoWayTrip };
      void handleFunc(params);
      setTripParams(params);
    }
  };

  return (
    <>
      <FormProvider {...methods}>
        <SearchTrip
          onSubmit={onSubmit}
          onCheckboxChange={handleCheckboxChange}
        />
        <div className={`relative ${loading ? "opacity-50" : "-mx-3 md:mx-0"}`}>
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center">
              Duke u mbushur të dhënat...
            </div>
          )}
          {!loading && (
            <PricingTable
              data={response?.data}
              tripParams={tripParams}
            />
          )}
        </div>
      </FormProvider>
    </>
  );
};

export default Prices;
